import register from '@kpsys/angularjs-register';
import CachedPermissionsDataService from './cached-permissions.data-service';
import LoanDataService from './loan.data-service';
import PermissionsDataService from './permissions.data-service';
import ObservableExemplarDataService from './observable-exemplar.data-service';
import ObservableAjaxServiceProvider from './observable-ajax.service';
import ObservableRecordDataService from './observable-record.data-service';
import AutocompleteSearchDataService from './autocomplete-search.data-service';
import ObservableCaptureDataService from './observable-capture.data-service';
import SdiRequestsDataService from './sdi-requests.data-service';
import CommentsDataService from './comments.data-service';
import LoanRequestDataService from './loan-request.data-service';
import PaymentDataService from './payment.data-service';
import DepartmentDataService from './department.data-service';
import {FormDataService} from './form.data-service';
import LocationDataService from './location.data-service';
import CommonSearchDataService from './common-search.data-service';
import MessageDataService from './message.data-service';
import LocalizationsDataService from './localizations-data.service';
import {AmountTypeDataService} from './amount-type.data-service';
import {SettingSectionsDataService} from './setting-sections.data-service';
import {FacetTypeDataService} from './facet-type.data-service';
import {FiltersDataService} from './filters.data-service';
import {LoanCategoryDataService} from './loan-category.data-service';
import {CancellationDataService} from './cancellation.data-service';
import {SearchDataService} from './search.data-service';
import {DirectoryDataService} from './directory.data-service';
import {ClientSessionVerifierDataService} from './client-session-verifier.data-service';

/**
 * @ngdoc module
 * @module portaro.data-services
 * @name portaro.data-services
 */

export default register('portaro.data-services')
    .provider(ObservableAjaxServiceProvider.providerName, ObservableAjaxServiceProvider)
    .service(PermissionsDataService.serviceName, PermissionsDataService)
    .service(CachedPermissionsDataService.serviceName, CachedPermissionsDataService)
    .service(ObservableCaptureDataService.serviceName, ObservableCaptureDataService)
    .service(ObservableExemplarDataService.serviceName, ObservableExemplarDataService)
    .service(ObservableRecordDataService.serviceName, ObservableRecordDataService)
    .service(AutocompleteSearchDataService.serviceName, AutocompleteSearchDataService)
    .service(LoanDataService.serviceName, LoanDataService)
    .service(SdiRequestsDataService.serviceName, SdiRequestsDataService)
    .service(CommentsDataService.serviceName, CommentsDataService)
    .service(LocalizationsDataService.serviceName, LocalizationsDataService)
    .service(LoanRequestDataService.serviceName, LoanRequestDataService)
    .service(PaymentDataService.serviceName, PaymentDataService)
    .service(DepartmentDataService.serviceName, DepartmentDataService)
    .service(FormDataService.serviceName, FormDataService)
    .service(LocationDataService.serviceName, LocationDataService)
    .service(CommonSearchDataService.serviceName, CommonSearchDataService)
    .service(MessageDataService.serviceName, MessageDataService)
    .service(AmountTypeDataService.serviceName, AmountTypeDataService)
    .service(SettingSectionsDataService.serviceName, SettingSectionsDataService)
    .service(FacetTypeDataService.serviceName, FacetTypeDataService)
    .service(FiltersDataService.serviceName, FiltersDataService)
    .service(LoanCategoryDataService.serviceName, LoanCategoryDataService)
    .service(CancellationDataService.serviceName, CancellationDataService)
    .service(SearchDataService.serviceName, SearchDataService)
    .service(DirectoryDataService.serviceName, DirectoryDataService)
    .service(ClientSessionVerifierDataService.serviceName, ClientSessionVerifierDataService)
    .name();
